// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Gxr1","head":"Table_head__73u17","col":"Table_col__1hqy5"};